import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl } from 'react-intl';
import css from './index.scss';
import Button from '../button/index';
import { Cross, View } from '../../helpers/icon-dictionary';


class NewCourseLabel extends PureComponent {
    render() {
        const { showCancel, label, handleOnView, handleOnCancel, hideButton } = this.props;
        const cancelButton = showCancel === false ? '' : (<div
            className={css.spacing}
            onClick={handleOnCancel}
            role="button"
            tabIndex={0}><Button
                containerClassName={css.cancel}
                icon={Cross}
                iconClassName={css.svgIconContainer}
            /></div>);
        return (
            <div className={css.container}>
                <div className={css.label}>{label}</div>
                <div className={css.buttonWrapper}>
                    {hideButton ? null : <div
                        className={css.spacing}
                        onClick={handleOnView}
                        role="button"
                        tabIndex={0}><Button
                            containerClassName={css.view}
                            icon={View}
                            iconClassName={css.svgIconContainer}
                        /></div>}
                    {cancelButton}
                </div>
            </div>
        );
    }
}

NewCourseLabel.propTypes = {
    label: PropTypes.string,
    showCancel: PropTypes.bool,
    handleOnView: PropTypes.func,
    handleOnCancel: PropTypes.func,
    hideButton: PropTypes.bool
};

export default injectIntl(styleable(css)(NewCourseLabel));



// WEBPACK FOOTER //
// ./app/components/new-course-label/index.js